import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Bonuses() {
  return <section className="w-full bg-sky px-4 py-14 md:py-20" data-id="element-59" data-mp="au1x4va5iuml">
      <div className="mx-auto max-w-6xl" data-id="element-60" data-mp="fu69c9411370">
        <SectionHeading kicker="Included with your purchase" title={<>
              5 exclusive clinical <span className="text-danger" data-id="element-62" data-mp="1wht5ekwmk8a">bonuses</span>
            </>} intro="Complementary resources to help you practice organizing your clinical reasoning and reviewing pediatric orthodontic cases." data-id="element-61" data-mp="fsv92j9sidkn" />

        <div className="mt-12 space-y-14 md:space-y-20" data-id="element-63" data-mp="3t0g9wqwooyje">
          {bonuses.map((b, i) => <article key={b.number} className="grid items-center gap-6 md:grid-cols-2 md:gap-12" data-id="element-64" data-mp="1mai3lz3qa0xb" data-mpi={i}>
              <div className={`-mx-4 md:mx-0 ${i % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-65" data-mp="1r931vszf6aj4">
                <img src={b.image} alt={`Bonus ${b.number}: ${b.title}`} className="w-full" loading="lazy" data-id="element-66" data-mp="1r6yz5ed9bhkf" />
              </div>
              <div data-id="element-67" data-mp="3dfv46vk2n786">
                <span className="inline-flex items-center gap-2 rounded-full bg-danger px-4 py-1.5 font-display text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-68" data-mp="3dek3x5pu4hlt">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="3n4mvr2l7zpik" />
                  Bonus #{b.number}
                </span>
                <h3 className="mt-4 font-display text-[1.9rem] font-extrabold uppercase leading-[1.02] text-navy sm:text-4xl" data-id="element-70" data-mp="2zgdco8fe5fv4">
                  {b.title}
                </h3>
                <p className="mt-3 text-lg font-bold leading-snug text-teal-dark" data-id="element-71" data-mp="38gs3fnb4jn60">{b.tagline}</p>
                <p className="mt-3 text-base leading-relaxed text-muted" data-id="element-72" data-mp="33gnucicjpupt">{b.body}</p>
                <div className="mt-5 flex items-center gap-3 rounded-2xl bg-white p-4 shadow-sm" data-id="element-73" data-mp="nprj961bulk3">
                  <span className="text-sm text-muted" data-id="element-74" data-mp="ir6tk0jpbk9w">
                    Suggested value: <s className="font-semibold" data-id="element-75" data-mp="it17uw0gwe50">${b.value}</s>
                  </span>
                  <span className="ml-auto rounded-lg bg-success px-3 py-1 font-display text-lg font-extrabold uppercase text-white" data-id="element-76" data-mp="3cin2d5fphif1">
                    Free today
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <CTAButton className="mt-14" label="Yes! I want all 5 bonuses" subtext="All bonuses included for $27 USD" data-id="element-77" data-mp="3qheckgrg6jxw" />
        <p className="mx-auto mt-4 max-w-xl text-center text-xs text-muted" data-id="element-78" data-mp="2tu9nobmhl27o">
          Bonus values are suggested reference values, not verified previous selling prices.
        </p>
      </div>
    </section>;
}